import { defineComponent as _defineComponent } from 'vue'
import { JointOptionTab } from '@/modules/ConfiguratorJoints/composables/useOptions';

interface Props {
    tabs: JointOptionTab[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalOptions',
  props: {
    tabs: null
  },
  emits: ["toggle"],
  setup(__props: any) {

const props = __props as {
    tabs: JointOptionTab[];
};





return { __sfc: true,props }
}

})